export default __webpack_public_path__ + "static/social_develop_box_d-6ecc656925e5d9ed5a195ebaac108b7e.png";